export default __webpack_public_path__ + "static/media/logotype.7a4d89e2.svg";